import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiLoginVariant } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { MOBILE_LOGIN } from '../../keys';
import { mobileDontKnowHowToSignInRoute, mobileQrCodeAccessRoute } from '../../routes';

export interface MobileLoginConfigurationSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
    isQrCodeFeatureEnabled: boolean;
}

const MobileLoginConfigurationSideNavigation = ({
    isAllowed,
    isQrCodeFeatureEnabled,
    ...restOfProps
}: MobileLoginConfigurationSideNavigationProps) => {
    const { translateKey } = useTranslate();
    if (!isAllowed) {
        return null;
    }
    return (
        <SideNavigationItem
            {...restOfProps}
            id="mobile-login"
            label={translateKey(MOBILE_LOGIN.MOBILE_SETTINGS_LOGIN)}
            icon={mdiLoginVariant}
        >
            {isQrCodeFeatureEnabled && (
                <SideNavigationItem label={translateKey(MOBILE_LOGIN.QR_CODE_ACCESS)} route={mobileQrCodeAccessRoute} />
            )}

            <SideNavigationItem
                label={translateKey(MOBILE_LOGIN.LOGIN_HELP_URL_PAGE_NAME)}
                route={mobileDontKnowHowToSignInRoute}
            />
        </SideNavigationItem>
    );
};

MobileLoginConfigurationSideNavigation.displayName = 'SideNavigationItem';

export { MobileLoginConfigurationSideNavigation };
